export default "__VITE_ASSET__BCRY$WsC__"